import { Location } from 'history';

const PATIENT_DASHBOARD_ROUTE = '/patient-dashboard';

const routes = (simulator = false) => {
  const query = simulator ? '?simulator=true' : '';
  return {
    LOG_IN: `/login${query}`,
    RESET_DOCUMENT: `/reset/document${query}`,
    RESET_O_DOCUMENT: `/reset-o/document${query}`,
    DOCUMENTS_LESSON_SUMMARIES: `/documents/lesson-summaries${query}`,
    DOCUMENTS_LESSON_CONTENT: `/documents/lesson-content${query}`,
    SIMULATOR: `/simulator${query}`,
    PATIENT_DASHBOARD: `${PATIENT_DASHBOARD_ROUTE}${query}`,
    PATIENT_DASHBOARD_OVERVIEW: `${PATIENT_DASHBOARD_ROUTE}/overview${query}`,
    PATIENT_DASHBOARD_LESSONS: `${PATIENT_DASHBOARD_ROUTE}/lessons${query}`,
    PATIENT_DASHBOARD_LESSONS_CHART: `${PATIENT_DASHBOARD_ROUTE}/lessons/chart${query}`,
    PATIENT_DASHBOARD_LESSONS_TABLE: `${PATIENT_DASHBOARD_ROUTE}/lessons/table${query}`,
    PATIENT_DASHBOARD_REWARDS: `${PATIENT_DASHBOARD_ROUTE}/rewards${query}`,
    PATIENT_DASHBOARD_CALENDAR: `${PATIENT_DASHBOARD_ROUTE}/calendar${query}`,
    PATIENT_DASHBOARD_CRAVINGS: `${PATIENT_DASHBOARD_ROUTE}/cravings${query}`,
  };
};

export const isLessonsChartRoute = (location: Location): boolean =>
  /lessons\/chart/i.test(location.pathname);

export default routes;
